import {Alert, Select, Stack, TextField} from '@wellstone-solutions/web';
import {toSelectItems, useNoteForm} from '../../NoteForm';
import {NOT_REACHED_REASONS, OTHER} from '../choices';
import type {NotReachedReason} from '../choices';
import type {ContactNoteAction, ContactNoteState} from '../state';

export const NotReachedSection = () => {
  const {state, dispatch} = useNoteForm<ContactNoteState, ContactNoteAction>();

  return (
    <Stack spacing={2}>
      <Alert severity="warning" title="Attempted contact - member not reached">
        Status, response and service sections are skipped. Attempts are
        non-billable.
      </Alert>
      <Select
        label="What prompted this attempt"
        items={toSelectItems(NOT_REACHED_REASONS)}
        value={state.notReachedReason ?? ''}
        canUnselect={false}
        containerProps={{required: true, fullWidth: true}}
        onChange={(event) =>
          dispatch({
            type: 'set',
            field: 'notReachedReason',
            value: event.target.value as NotReachedReason,
          })
        }
      />
      {state.notReachedReason === OTHER && (
        <TextField
          required
          label="Other (specify)"
          value={state.notReachedReasonOther}
          onChange={(event) =>
            dispatch({
              type: 'set',
              field: 'notReachedReasonOther',
              value: event.target.value,
            })
          }
        />
      )}
      <TextField
        type="datetime-local"
        label="Next attempt"
        value={state.nextAttemptAt}
        InputLabelProps={{shrink: true}}
        onChange={(event) =>
          dispatch({
            type: 'set',
            field: 'nextAttemptAt',
            value: event.target.value,
          })
        }
      />
      <TextField
        multiline
        minRows={2}
        label="Note"
        value={state.notReachedNote}
        onChange={(event) =>
          dispatch({
            type: 'set',
            field: 'notReachedNote',
            value: event.target.value,
          })
        }
      />
    </Stack>
  );
};
